/**
 * Calcula el estado del producto según stock
 * @param {number} currentStock
 * @param {number} minStock
 * @param {number} maxStock
 * @returns {number} Estado del producto (1 a 5)
 */
export function calculateProductStatus(currentStock, minStock, maxStock) {
  if (currentStock === 0) {
    return 5; // Agotado
  }

  if (currentStock < minStock) {
    return 4; // Resurtir
  }

  if (currentStock === minStock) {
    return 3; // Mínimo
  }

  if (currentStock > minStock && currentStock < maxStock) {
    return 2; // Bajo
  }

  if (currentStock >= maxStock) {
    return 1; // Óptimo
  }

  // Fallback (no debería llegar aquí)
  return null;
}

// export function validateStockInputs(currentStock, minStock, maxStock) {
//   if (
//     currentStock == null ||
//     minStock == null ||
//     maxStock == null
//   ) {
//     throw new Error('Valores de stock incompletos');
//   }

//   if (
//     currentStock < 0 ||
//     minStock < 0 ||
//     maxStock < 0
//   ) {
//     throw new Error('Los valores de stock no pueden ser negativos');
//   }

//   if (minStock > maxStock) {
//     throw new Error('El stock mínimo no puede ser mayor al máximo');
//   }

//   return true;
// }

